/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ref.vue?vue&type=template&id=6a2b4f86&scoped=true"
import script from "./ref.vue?vue&type=script&lang=js"
export * from "./ref.vue?vue&type=script&lang=js"
import style0 from "./ref.vue?vue&type=style&index=0&id=6a2b4f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b4f86",
  null
  
)

export default component.exports